import LoadingSkeleton from "./loading_skeleton.tsx";
import { SecondaryBody } from "@sprout/typography.tsx";
import useTranslation from "@hooks/use_translation.ts";
import useTimeSincePublishedText from "@hooks/use_time_since_published_text.ts";

type Props = {
  loading?: boolean;
  publishedAt: string;
  viewed: boolean;
};

const Footer = ({ loading, publishedAt, viewed }: Props) => {
  const { t } = useTranslation("jobSearch");
  const timeSincePublished = useTimeSincePublishedText(publishedAt);

  return loading ? (
    <LoadingSkeleton className="h-4 w-[80px]" />
  ) : (
    <SecondaryBody>
      {timeSincePublished}
      {viewed && ` • ${t("viewed")}`}
    </SecondaryBody>
  );
};

export default Footer;
